var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.259122 5.56474L7.83254 8.80622C7.88597 8.82954 7.94304 8.84065 8.00021 8.84065C8.05738 8.84065 8.11419 8.82896 8.16789 8.80622L15.7411 5.56474C15.901 5.49614 16.0035 5.33778 15.9998 5.16384C15.9963 4.98979 15.8874 4.8357 15.725 4.77411L8.15151 1.89372C8.05365 1.85639 7.94593 1.85639 7.84833 1.89372L0.275126 4.77405C0.112715 4.83565 0.00389653 4.99006 0.000106056 5.16379C-0.00347383 5.33747 0.0990795 5.4964 0.259122 5.56474ZM7.99995 2.74847L14.435 5.19585L7.99995 7.95026L1.56483 5.1959L7.99995 2.74847Z",
    fill: "#5A5F89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259119 7.40935L7.99995 10.7226L15.7406 7.40935C15.9574 7.31664 16.0576 7.06594 15.9649 6.84952C15.8725 6.63351 15.6226 6.53206 15.4053 6.62519L7.99995 9.79508L0.594365 6.62519C0.377676 6.53233 0.127242 6.63325 0.0345334 6.84952C-0.0581752 7.0662 0.0424829 7.31664 0.259119 7.40935Z",
    fill: "#5A5F89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259119 9.11482L7.99995 12.4282L15.7406 9.11482C15.9574 9.02211 16.0576 8.77168 15.9649 8.55515C15.8725 8.33914 15.6226 8.23754 15.4053 8.33083L7.99995 11.5007L0.594365 8.33088C0.377676 8.23812 0.127242 8.33888 0.0345334 8.5552C-0.0581752 8.77173 0.0424829 9.02211 0.259119 9.11482Z",
    fill: "#5A5F89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259119 10.8207L7.99995 14.1341L15.7406 10.8207C15.9574 10.728 16.0576 10.4775 15.9649 10.261C15.8725 10.045 15.6226 9.94402 15.4053 10.0367L7.99995 13.2066L0.594365 10.0367C0.377676 9.94397 0.127242 10.0447 0.0345334 10.261C-0.0581752 10.4775 0.0424829 10.728 0.259119 10.8207Z",
    fill: "#5A5F89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProject);
export default __webpack_public_path__ + "static/media/Sidebar-Project.598d52699a434eb72a8ca13971197458.svg";
export { ForwardRef as ReactComponent };